import React from 'react';
import classNames from 'classnames';
import styles from './Badge.module.scss';

interface BadgeProps extends React.HTMLAttributes<HTMLElement> {
  as?: keyof JSX.IntrinsicElements | React.ElementType;
}

const Badge: React.FC<BadgeProps> = ({ as: Component = 'span', children, className, ...rest }) => {
  return (
    <Component className={classNames(styles.badge, className)} {...rest}>
      {children}
    </Component>
  );
};

export default Badge;
